/**
 * Created by markusr on 9.6.2015.
 * This task type has an extension (OpenQuestionEmails) activated with a page component
 * @component {"type":"OpenQuestionEmails","version":"1.1"}
 * @component {"type":"CharCounter","version":"1.0"}
 */

define('task-open-question',['knockout', 'helpers', 'modal', 'training', 'user-answers'], function(ko, helpers, Modal, Training, UserAnswers) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            lang = null,
            modal = null,
            userVM = parentVM.user,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            training = new Training();

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        lang = dataContext.learning.lang;

// ------------- Max words -------------

        self.counters = ko.computed(function() {
            var res = {},
                content = training.getContent(entityVM.ID());

            if (content.typeID !== 12) {
                return res;
            }

            var counter = helpers.component.getContent(content.componentsJSON, 'CharCounter'),
                prop = helpers.component.parseProp(counter, 'limits', 'CharCounterLimit'),
                options = (content.answers.length) ? content.answers : content.questions;

            if (!prop.length && !training.scormPackage) {
                return res;
            }

            options.forEach(function(option, i) {
                res[option.id] = (options.length <= prop.length) ? parseInt(prop[i].limit) : (prop.length) ? parseInt(prop[0].limit) : (training.scormPackage) ? Math.floor(255/ options.length) : 0;
            });

            return res;
        });

        var setContent = function(ID, counter, node) {
            var counters = self.counters();

            counter = counter || document.getElementById(ID + '-counter');
            node = node || document.getElementById(ID);

            if (!counter || !node || !counters[ID]) {
                return;
            }

            var value = node.value,
                res = value.replace(/^\s+/g, '').replace(/\s+/g, ' ');

            if (res.length > counters[ID]) {
                res = res.slice(0, counters[ID]);
                node.value = res;
            }

            counter.innerHTML = res.length + '/' + counters[ID];
        }

        self.validateMaxWords = function() {
            var ID = this.id,
                res = '',
                input = document.getElementById(ID),
                arr = [],
                max = parseInt(entityVM.maximumWords()) || '',
                value = (input) ? input.value : '';

            res = value.replace(/^\s+/g, '').replace(/\s+/g, ' ');

            if (max && res) {
                arr = res.split(' ');

                if (arr.length > max) {

                    modal = new Modal({
                        content: lang.maximumWords.replace('{max}', max),
                        enterClose: true,
                        showClose: false
                    });

                    modal.addButtons([
                        {action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok}
                    ]);

                    modal.open();

                    res = arr.splice(0, max).join(' ');
                }

                input.value = res;
            }

            setContent(ID, null, input);
        };

        ko.bindingHandlers.charCounter = {
            update: function (counter, valueAccessor) {
                var data = ko.unwrap(valueAccessor());

                setContent(data.ID, counter);
            }
        };


// ------------- Multiple emails -------------
        self.visibleEmails = ko.observable(1);

        self.userEmail = ko.observable(false);

        self.addEmailLabelPrefix = ko.observable('');

        self.removeEmailLabelPrefix = ko.observable('');

        self.componentEmails = ko.computed(function() {
            var entityContent = entityVM.entityContent(),
                ID = entityContent.ID,
                content = helpers.component.getContent(entityContent.componentsJSON, 'OpenQuestionEmails'),
                counter = 0,
                userAnswers = new UserAnswers(),
                addPrefix = (content.addLabel) ? content.addLabel : '',
                removePrefix = (content.removeLabel) ? content.removeLabel : '',
                total = (content.total) ? parseInt(content.total) : 1;

            self.userEmail(content.userEmail);
            self.addEmailLabelPrefix(addPrefix);
            self.removeEmailLabelPrefix(removePrefix);

            if (userAnswers.isTaskPageAnswered(ID)) {
                var answers = userAnswers.getUserAnswer(ID).answers;

                for (var i = 0; i < answers.length; i++) {
                    if (answers[i].answerText && answers[i].answerText !== '-') {
                        counter++;
                    }
                }

                self.visibleEmails(counter);
            } else {
                self.visibleEmails(total);
            }

            return Object.keys(content) || [];
        });

        self.isEmails = ko.computed(function() {
            return !!self.componentEmails().length;
        });

        self.maxEmails = ko.computed(function() {
            return (trainingVM.computedAnswers()) ? trainingVM.computedAnswers().length : 0;
        });

        self.isVisibleEmail = function(index) {
            return index < self.visibleEmails();
        };

        self.addEmails = function(no) {
            no = no || 1;
            self.visibleEmails(self.visibleEmails() + no);
            trainingVM.validate();
        }

        self.addEmail = function() {
            self.addEmails(1);
        };

        self.removeEmails = function(no) {
            no = no || 1;
            self.visibleEmails(self.visibleEmails() - no);
            trainingVM.validate();
        };

        self.removeEmail = function() {
            self.removeEmails(1)
        };

        self.addEmailLabel = ko.computed(function() {
            return self.addEmailLabelPrefix() + ' ' + (self.visibleEmails() + 1);
        });

        self.addEmailVisible = ko.computed(function() {
            return (self.visibleEmails() < self.maxEmails());
        });

        self.removeEmailLabel = ko.computed(function() {
            return self.removeEmailLabelPrefix() + ' ' + self.visibleEmails();
        });

        self.removeEmailVisible = ko.computed(function() {
            return (self.visibleEmails() > 1);
        });

        self.enteredEmail = function(ID, index) {
            var answer = trainingVM.getAnswerTextByAnswerIdAlways(ID),
                input = document.getElementById(ID),
                value = (input && input.value) ? input.value : '',
                validate = function() {
                    setTimeout(function() {
                        if (!trainingVM.isTaskAnswered()) {
                            trainingVM.validate();
                        }
                    }, 10);
                };

            if (!self.isVisibleEmail(index)) {
                return '-';
            }

            if (value && value !== '-' && self.isVisibleEmail(index) && trainingVM.savedAnswers() !== 'hide') {
                return value;
            }

            if (answer && answer !== '-' && self.isVisibleEmail(index)) {
                validate();
                return answer;
            }

            if (index === 0 && self.userEmail() && userVM.email()) {
                validate();
                return userVM.email();
            }

            return (self.isVisibleEmail(index)) ? '' : '-';
        }

    }
});


